

// src/themeStyles.js
import theme from "./theme";

// Dropdowns, Tables, Pagination
export const dropdownStyle = {
  marginRight: theme.spacing.md,
  padding: theme.spacing.sm,
  borderRadius: theme.radius.md,
  border: "1px solid #ccc",
};

export const thStyle = {
  padding: theme.spacing.md,
  textAlign: "left",
  fontWeight: theme.font.weight.bold,
};

export const tdStyle = {
  padding: theme.spacing.md,
};

export const paginationButtonStyle = {
  padding: `${theme.spacing.sm} ${theme.spacing.md}`,
  backgroundColor: "#eee",
  borderRadius: theme.radius.lg,
  fontWeight: theme.font.weight.medium,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.xs,
};

// Modal Styles
export const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

export const modalContentStyle = {
  width: "90%",
  maxWidth: "600px",
  backgroundColor: "#fff",
  padding: theme.spacing.lg,
  borderRadius: theme.radius.lg,
  boxShadow: theme.shadow.soft,
  position: "relative",
};

export const closeButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "15px",
  background: "transparent",
  border: "none",
  fontSize: "1.5rem",
  cursor: "pointer",
};

export const inputStyle = {
  padding: theme.spacing.sm,
  borderRadius: theme.radius.md,
  border: "1px solid #ccc",
  width: "100%",
};


export const searchInputStyle = {
  padding: "8px 12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  marginBottom: "10px",
  width: "250px",
  outline: "none",
};


export const labelStyle = {
  display: "block",
  marginBottom: theme.spacing.xs,
  fontWeight: theme.font.weight.medium,
  color: theme.colors.grayDark,
};

export const errorStyle = {
  backgroundColor: theme.colors.dangerLight,
  color: theme.colors.dangerText,
  padding: theme.spacing.sm,
  borderRadius: theme.radius.md,
  marginBottom: theme.spacing.md,
};

export const buttonStyle = {
  padding: `${theme.spacing.sm} ${theme.spacing.md}`,
  backgroundColor: theme.colors.primary,
  color: "#fff",
  border: "none",
  borderRadius: theme.radius.md,
  fontWeight: theme.font.weight.medium,
  cursor: "pointer",
};
